import { Typography, Form, Row, Col } from 'antd'
import ConcurrenceLevelFormItem from '../../../ConcurrenceLevelFormItem'
import DisciplinesFormItem from '../../../DisciplinesFormItem'
import IssueFormItem from '../../../IssueFormItem'
import LocationFormItem from '../../../LocationFormItem'
import ResolutionFormItem from '../../../ResolutionFormItem'
import { CIMSTags } from 'components/CIMSTags'
import { useFDCTrackerContext } from '../../../../../../FDCTrackerContext'

const DetailsBody: React.FC = () => {
  const {
    mutations: {
      submit: { state },
    },
  } = useFDCTrackerContext()
  return (
    <>
      {!state && (
        <>
          <CIMSTags
            header={{
              content:
                'The following must be configured, in addition to the Issue, to submit a Field Design Change.',
            }}
            direction={{ header: 'vertical', tags: 'horizontal' }}
            tags={[
              { text: 'Concurrence Level' },
              { text: 'Location' },
              { text: 'Disciplines' },
            ]}
          />
          <Typography.Paragraph>
            Otherwise, the resulting Field Design Change will be drafted and may
            be submitted later.
          </Typography.Paragraph>
        </>
      )}
      <Form.Item hidden name="number" />
      <IssueFormItem />
      <ResolutionFormItem />
      <LocationFormItem required={!!state} />
      <Row gutter={16}>
        <Col span={12}>
          <ConcurrenceLevelFormItem required={!!state} filtered={!state} />
        </Col>
        <Col span={12}>
          <DisciplinesFormItem required={!!state} />
        </Col>
      </Row>
    </>
  )
}

export default DetailsBody
